import restClient from 'Shared/hooks/restClient'
import ExportConfirmationModal from 'Shared/components/ExportConfirmationModal'
import './ActionHeader.scoped.scss'

export default function ActionHeader({ flowId, actionId, title }) {
  const [exportPassword, setExportPassword] = useState(null)

  const doExport = () => {
    restClient.post(`/api/flows/${flowId}/actions/${actionId}/export`).then((response) => {
      setExportPassword(response.data.password)
    })
  }

  return (
    <>
      <div className="action-header">
        <h2 className="no-margin-top">{title}</h2>
        <a className="button secondary" onClick={doExport} >
          <SvgIconsDownload />
          Export results
        </a>
      </div>
      <ExportConfirmationModal
        exportPassword={exportPassword}
        setExportPassword={setExportPassword}
        entityName="action"
      />
    </>
  )
}
